<!-- -->

<template>
  <div
    class="title-wrapper"
    :style="styleProps">
    <!-- Title -->
    <div class="flex" >
      <div
        class="title greedy ellipsis flex flex-align-center"
        :class="[type]" >{{ title }}
        <template v-if="count !== null && total !== null">
          <DotSeparator
            :color="SBColors.blackUltralight"
            :size="4"
            style="margin-left: 8px; margin-right: 8px;" />
          <p class="count" ><span class="lighter">{{ count | bigDigits }}</span> / {{ total | bigDigits }}</p>
        </template>
        <SBIcon
          v-if="collapsable"
          class="mx-2"
          :icon="SBIconList.DOWN_ARROW"
          :color="SBColors.greyPrimary"
          :rotate="collapsed ? -90 : 0"
          :size="10"
          animate />
      </div>
      <!-- <div class="greedy" /> -->
      <div
        v-if="action"
        class="action flex flex-align-center show-hand"
        :class="{ red: action.buttonVariant && action.buttonVariant.toLowerCase() === 'red' }"
        @click="action.run" >
        <span>{{ action.buttonText }}</span>
        <svg
          v-if="action.buttonIcon && typeof action.buttonIcon === 'string' && action.buttonIcon.endsWith('.svg')"
          class="dot svg ml-1 external-svg"
          :data-src="action.buttonIcon"
          style="width: 14px; height: 14px;" />
        <img
          v-else-if="action.buttonIcon && typeof action.buttonIcon === 'string'"
          :src="action.buttonIcon"
          style="width: 14px; height: 14px;"
          class="ml-1" >
        <SBIcon
          v-else-if="action.buttonIcon"
          class="ml-1"
          :icon="action.buttonIcon"
          :color="SBColors.blackPrimary"
          :size="14" />
      </div>
      <!-- Do not show "optional" if buttons type is being rendered. -->
      <div
        v-if="optional"
        class="optional" >Optional</div>
      <div
        v-if="modalInfo"
        class="modal-info flex flex-align-center show-hand ml-2"
        @click="showInfoModal" >
        <svg
          v-if="modalInfo.buttonPrefixIcon && typeof modalInfo.buttonPrefixIcon === 'string' && modalInfo.buttonPrefixIcon.endsWith('.svg')"
          class="dot svg mr-1 external-svg"
          :data-src="modalInfo.buttonPrefixIcon"
          style="width: 12px; height: 12px;" />
        <img
          v-else-if="modalInfo.buttonPrefixIcon && typeof modalInfo.buttonPrefixIcon === 'string'"
          :src="modalInfo.buttonPrefixIcon"
          style="width: 12px; height: 12px;"
          class="mr-1"
        >
        <span>{{ modalInfo.buttonText }}</span>
      </div>
    </div>
    <!-- Subtitle prefix -->
    <div
      v-if="subtitle"
      class="subtitle flex flex-align-center">
      <svg
        v-if="subtitlePrefixIcon && typeof subtitlePrefixIcon === 'string' && subtitlePrefixIcon.endsWith('.svg')"
        class="mr-1 flex-start-image"
        :data-src="subtitlePrefixIcon"
        fill="currentColor"
        width="10"
        height="10" />
      <img
        v-else-if="subtitlePrefixIcon && typeof subtitlePrefixIcon === 'string'"
        :src="subtitlePrefixIcon"
        style="width: 10px; height: 10px;"
        class="mr-1 flex-start-image"
      >
      <SBIcon
        v-else-if="!noSubtitlePrefixIcon"
        class="mr-1"
        :icon="subtitlePrefixIcon || SBIconList.INFO"
        :color="SBColors.greyLight"
        :size="10" />
      <span>{{ subtitle }}</span>
    </div>
    <span
      v-if="bottomSpacer"
      :style="{ display: 'block', height: `${bottomSpacer}px` }" />

    <!-- Info modal -->
    <InfoModal
      v-if="modalInfo"
      ref="infoModal"
      :data="modalInfo" />
  </div>
</template>

<script>
import randomString from '@/helpers/randomString';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import DotSeparator from '@/components/common/DotSeparator';
import InfoModal from '../forms_schema/modals/InfoModal';

export default {
  name: 'Title',
  components: {
    SBIcon,
    InfoModal,
    DotSeparator,
  },
  props: {
    action: {
      type: Object,
      required: false,
      default: null,
    },
    title: {
      type: [String, null],
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    subtitle: {
      type: [String, null],
      required: false,
      default: null,
    },
    subtitlePrefixIcon: {
      type: [String, null],
      required: false,
      default: null,
    },
    noSubtitlePrefixIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    optional: {
      type: Boolean,
      required: false,
      default: false,
    },
    modalInfo: {
      type: Object,
      required: false,
      default: null,
    },
    bottomSpacer: {
      type: Number,
      required: false,
      default: 0,
    },
    collapsable: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    count: {
      type: Number,
      required: false,
      default: null,
    },
    total: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      randomId: randomString(),
      SBColors,
      SBIconList,
    };
  },
  computed: {
    styleProps() {
    //   let styles = {};
    //   if (this.schema.width && this.schema.width > 0) {
    //     styles = {
    //       flexBasis: `calc(${this.schema.width}% - 10px)`, // it is important to have 10px padding which matches the gap between the columns. The last gap will be removed anyway and the columns will stretch due to the flex-grow property.
    //       flexGrow: this.schema.width,
    //       width: '1px',
    //     };
    //   }
    //   if (this.schema.color) {
    //     styles = {
    //       ...styles,
    //       '--background-color': this.schema.color,
    //     };
    //   } else {
    //     styles = {
    //       ...styles,
    //       '--background-color': this.schema.color || this.SBColors.greyUltralight,
    //     };
    //   }
      return {};
    },
  },
  created() {},
  mounted() {},
  methods: {
    showInfoModal() {
      this.$refs.infoModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.title-wrapper {
  &.half-top-gap {
    margin-top: -10px;
  }

  &.no-top-gap {
    margin-top: -18px;
  }

  .title, .title p {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 500;
    color: $blackPrimary;
    line-height: normal !important;

    &.normal {
      font-weight: 400;
    }

    &.no-margin {
      margin: 0;
    }
  }

  .title p {
    margin: 0 !important;
    .lighter {
      color: $blackUltralight;
    }
  }

  .modal-info {
    margin: 0 0 8px !important;
    * {
      font-size: 14px !important;
      color: $bluePrimary !important;
      line-height: normal !important;
    }

    &:hover * {
      color: $blackPrimary !important;
    }
  }

  ::v-deep .action {
    margin-bottom: 8px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    color: $blackPrimary !important;

    span {
      font-size: 14px !important;
      font-weight: 500 !important;
    }

    &.red {
      * {
        color: $redPrimary;
      }
      .icon.mask {
        background-color: $redPrimary !important;
      }
    }

    &:hover {
      * {
        color: $blackPrimary;
      }
      .icon.mask {
        background-color: $blackPrimary !important;
      }
    }
  }

  .optional {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 500;
    text-align: right;
    color: $blackUltralight;
    line-height: normal !important;
  }

  // SB-NOTE - coloring the svg based on color value
  ::v-deep .external-svg path {
    fill: currentColor;
  }

  .subtitle {
    font-size: 12px !important;
    font-weight: normal !important;
    text-align: left !important;
    color: #7C8B91 !important;
    margin-bottom: 8px !important;
    line-height: 1.4;
  }

  &.collapsed {
    .title {
      margin-bottom: 0 !important;
    }
  }
}
</style>
